import { ActionTypes as action } from "./action-types";
import meetingService from "../../../api/meetingService";
import peopleService from "../../../api/peopleService";
import { subtractFromDate, setFilterFormData } from "../../../utils/util";
import isEmpty from "lodash";

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const actions = {
  setMeetingTimerCount({ commit }, meetingTimerClick) {
    commit("setMeetingTimerCount", meetingTimerClick);
  },
  setMeetingTimerPopup({ commit }, meetingTimerPopup) {
    commit("setMeetingTimerPopup", meetingTimerPopup);
  },
  async getMeetingList({ commit, getters, state }, isFilterApply = true) {
    let filter = null;
    if (isFilterApply) {
      filter = state.default_meetting_filter;
    }
    const data = await meetingService.getMeetingList(filter);
    commit(action.GET_MEETING_LIST, data);
    return data;
  },
  async getCustomMeetingList({ commit }, filter) {
    const data = await meetingService.getMeetingList(filter, true);
    commit(action.GET_CUSTOM_MEETING_LIST, data);
    return data;
  },
  async getDefaultMeetingList({ commit }, filter) {
    const data = await meetingService.getMeetingListForCalendar(filter);
    commit(action.GET_DEFAULT_MEETING_LIST, data);
    return data;
  },
  async getMeetingById({ commit }, payload) {
    const { id, isSilentRequest = false } =
    typeof payload === "object" && payload !== null
      ? payload
      : { id: payload, isSilentRequest: false };

    const data = await meetingService.getMeetingById(id, isSilentRequest);
    commit(action.GET_MEETING_BY_ID, data);
    return data;
  },
  async getShortMeetingById({ commit }, payload) {
    const { id, isSilentRequest = false } =
    typeof payload === "object" && payload !== null
      ? payload
      : { id: payload, isSilentRequest: false };

    const data = await meetingService.getShortMeetingById(id, isSilentRequest);
    return data;
  },
  async getMeetingByIdForSignalR({ commit }, id) {
    return await meetingService.getMeetingById(id);
  },
  async createMeeting({ dispatch, commit }, data) {
    const result = await meetingService.createMeeting(data);
    return result;
  },
  async updateMeeting({ dispatch, commit }, data) {
    const result = await meetingService.updateMeeting(data);
    return result;
  },
  async createAgendaMeeting({ dispatch, commit }, data) {
    const result = await meetingService.createMeeting(data);
    return result;
  },
  async updateAgendaMeeting({ dispatch, commit }, data) {
    const result = await meetingService.updateMeeting(data);
    return result;
  },
  async deleteMeeting({ dispatch, commit, state }, id) {
    const result = await meetingService.deleteMeeting(id);
    const isFilterApply = !isEmpty(state.default_meetting_filter);
    await dispatch("getMeetingList", isFilterApply);
    return result;
  },
  async deleteMeetingForCalendar({ dispatch, commit }, id) {
    const result = await meetingService.deleteMeeting(id);
    return result;
  },
  async getConvocationById({ commit }, id) {
    const data = await meetingService.getConvocationContentById(id);
    commit(action.GET_CONVOCATION_BY_ID, data);
    return data;
  },
  async setDefaultFilterType({ dispatch, commit, vm }, formData) {
    const section = formData?.section ?? "";
    let defaultFilterKey =
      "default_meeting_filter#" + sessionStorage.getItem("tenantId");
    if (formData && formData.filter_type) {
      formData = setFilterFormData(formData);
      localStorage.setItem(defaultFilterKey, JSON.stringify(formData));
    } else if (localStorage.getItem(defaultFilterKey) !== null) {
      formData = localStorage.getItem(defaultFilterKey)
        ? JSON.parse(localStorage.getItem(defaultFilterKey))
        : {};
    } else {
      const start_date = subtractFromDate("month", 1)
        .toISOString()
        .substr(0, 10);
      const end_date = subtractFromDate().toISOString().substr(0, 10);
      formData = {
        filter_type: "upcoming",
        label: "Upcoming",
        start_date: start_date,
        end_date: end_date,
      };
    }
    commit(action.SET_MEETING_FILTER_TYPE, formData);
    if (section === "document") {
      await dispatch("document/getMeetingListForDocument", true, {
        root: true,
      });
    } else {
      await dispatch("getMeetingList");
    }
  },
  async downloadConvocationMessage({ commit }, id) {
    const res = await meetingService.downloadConvocationMessage(id);
    return res;
  },
  async updateMeetingTopicVote({ dispatch, commit }, data) {
    const result = await meetingService.updateMeetingTopicVote(data);
    return result;
  },
  async getMeetingTopicVote({ commit }, data) {
    const result = await meetingService.getMeetingTopicVote(
      data.meetingId,
      data.topicId
    );
    return result;
  },
  async getUserMeetingVotes({ commit }, data) {
    let isSilentRequest = false
      if(data.isSilentRequest){
        isSilentRequest = data.isSilentRequest
      }
    const result = await meetingService.getUserMeetingVotes(data.meetingId, isSilentRequest);
    return result;
  },
  setMeetingType({ commit }, label) {
    commit("setMeetingType", label);
  },
  async getMeetingIDByType({ commit }, type) {
    const data = await meetingService.getMeetingIDByType(type);
    return data;
  },
  async getAgendaMeetingList({ }, filter) {
    const data = await meetingService.getMeetingList(filter);
    return data;
  },
  async getUpcomingMeetingList({ commit }, params) {
    const data = await meetingService.getUpcomingMeetingListByType(params);
    commit(action.GET_UPCOMMING_MEETING_LIST, data);
  },
  async createMeetingSeries({ dispatch, commit }, data) {
    const meetingFormData = {
      ...data,
      timeZone: timeZone,
    };
    const result = await meetingService.createMeetingSeries(meetingFormData);
    return result;
  },
  async deleteMeetingSeries({ dispatch, state }, id) {
    const result = await meetingService.deleteMeetingSeries(id);
    const isFilterApply = !isEmpty(state.default_meetting_filter);
    await dispatch("getMeetingList", isFilterApply);
    return result;
  },
  async updateMeetingSeries({ dispatch }, data) {
    const meetingFormData = {
      ...data,
      timeZone: timeZone,
    };
    const result = await meetingService.updateMeetingSeries(meetingFormData);
    return result;
  },
  async getDeletedUsersList({ }, userIds) {
    const result = await peopleService.getDeletedUsersList(userIds);
    return result;
  },
  async getVotersDetails({ }, meetingId) {
    const result = await meetingService.getVotersDetails(meetingId);
    return result;
  },
  async getMeetingVotersSummary({ commit }, meetingId) {
    const result = await meetingService.getMeetingVotersSummary(meetingId);
    commit(action.GET_MEETING_VOTER_SUMMARY, result.data);
    return result;
  },
  async saveTags({ commit }, payload) {
    const res = await meetingService.saveTags(payload);
    return res;
  },
  async searchTags({ commit }, payload) {
    const res = await meetingService.searchTags(payload);
    return res;
  },
  async getMomAttendees({ }, meetingId) {
    const result = await meetingService.getMomAssignees(meetingId);
    return result;
  },
  async getMomComments({ commit }, meetingId) {
    const data = await meetingService.getMomComments(meetingId);
    commit(action.GET_MEETING_COMMENT_LIST, data.data);
    return data;
  },
  async getMomcommentslog({ commit }, meetingId) {
    const data = await meetingService.getMomcommentslog(meetingId);
    commit(action.GET_MEETING_MOM_LOG, data.data);
    return data;
  },
  setTranscriptionStatus({ commit }, data) {
    commit("setTranscriptionStatus", data);
  },
  setWanSignEmailStatus({ commit }, data) {
    commit("setWanSignEmailStatus", data);
  },
  async getDeletedUsersListTemp({ commit, state }, userIds) {
    const missingIds = findMissingDeletedIds(state.deletedUserList, userIds);
    if (missingIds.length > 0) {
      const result = await peopleService.getDeletedUsersList(missingIds);
      if (state.deletedUserList.length) {
        const users = result.data;
        users.forEach((user) => {
          if (!state.deletedUserList.some((u) => u.id === user.id)) {
            commit(action.ADD_DELETED_USER, user);
          }
        });
        return Promise.resolve(state.deletedUserList);
      } else {
        commit(action.SET_DELETED_USER, result.data);
        return Promise.resolve(state.deletedUserList);
      }
    } else {
      return Promise.resolve(state.deletedUserList);
    }
  },
  resetState({ commit }) {
    commit(action.RESET_STATE);
  },

  async momWansignDocumentReset({ }, meetingId) {
    const result = await meetingService.momWansignDocumentReset(meetingId);
    return result;
  },

  async exportIcs({ }, params) {
    const result = await meetingService.exportIcs(params);
    return result;
  },

  async updateMeetingAttendance({ }, data) {
    const result = await meetingService.updateMeetingAttendance(data);
    return result;
  },
  async validateMoveMeetingTopic({ }, data) {
    const result = await meetingService.validateMoveMeetingTopic(data);
    return result;
  },
  async getMeetingFeedbacks({ }, payload) {
    const { id: meetingId, isSilentRequest = false } =
    typeof payload === "object" && payload !== null
      ? payload
      : { id: payload, isSilentRequest: false };

    return await meetingService.getMeetingFeedbacks(meetingId, isSilentRequest);
  },
  
  async setVotingData({ commit }, data) {
      commit('setVotingData', data)
  },
  async addMeetingTopicFeedback({ }, data) {
    const result = await meetingService.addMeetingTopicFeedback(data);
    return result;
  },
  async addAttendeeNote({ }, data) {
    const result = await meetingService.addAttendeeNote(data);
    return result;
  }
};

function findMissingDeletedIds(data, userIds) {
  const existingIds = data.map((item) => item.id);
  return userIds.filter((id) => !existingIds.includes(id));
}

export default actions;
